import type { Iban } from "@/features/user/types";
import { fetchServer } from "@/features/utils/fetch";
import { CheckValidationIban } from "../../quiz/types";

export class IbanApiClient {
  //this route has been updated in the front we need to update in bitbang aswell to accept contextLegalEntityUuid
  static async create(iban: Iban, id?: string): Promise<CheckValidationIban> {
    const response = await fetchServer(
      !id ? "/aliasIban" : `/aliasIban?contextLegalEntityUuid=${id}`,
      {
        method: "POST",
        reloadOn401: false,
        mainRoot: false,
        body: iban
      }
    );

    if (!response.ok) throw new Error("Error");

    const res = await response.json();
    return res;
  }
}
